// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);"]);
// Module
exports.push([module.id, ":root{--app-max-width:1400px!important;--app-margin:0 0!important;--color-red:#ff554f!important;--color-red-active:#fc2019!important;--color-green:#9eb992!important;--color-green-active:#4b8709!important;--producttitle-text-size:14px!important;--productprice-text-size:14px!important;--font-family:\"Open Sans\",sans-serif!important}", ""]);
// Exports
module.exports = exports;
